import React from 'react';
import TitleWithIcon from '../../components/common/TitleWithIcon';
import SectionBlueAndCartel from '../../components/section/SectionBlueAndCartel';
import SectionModuleEURegulation from '../../components/section/SectionModuleEURegulation';
import SectionSignUp from '../../components/section/SectionSignUp';
import { SectionStore } from '../../components/section/SectionStore';
import { TEXT_KEYS } from '../../constants/textKeys';
import IMAGES_PATH from '../../Images';
import { t } from '../../translation/translation';
import './style.css'

const CARTEL_ITEMS = [
    {
        icon: IMAGES_PATH.ICON_WORLD,
        title: <h4 className="styled-h4">{t(TEXT_KEYS.EU_REGULATION_CARTEL_TITLE_1)}</h4>,
        description: t(TEXT_KEYS.EU_REGULATION_CARTEL_DESCRIPTION_1),
    },
    {
        icon: IMAGES_PATH.ICON_AI,
        title: <h4 className="styled-h4">{t(TEXT_KEYS.EU_REGULATION_CARTEL_TITLE_2)}</h4>,
        description: t(TEXT_KEYS.EU_REGULATION_CARTEL_DESCRIPTION_2),
    },
    {
        icon: IMAGES_PATH.ICON_BOOK,
        title: <h4 className="styled-h4">{t(TEXT_KEYS.EU_REGULATION_CARTEL_TITLE_3)}</h4>,
        description: t(TEXT_KEYS.EU_REGULATION_CARTEL_DESCRIPTION_3),
    },
];

export const EURegulation = () => {

    const firstTitlePart = <h2 className='text-blue'>{t(TEXT_KEYS.EU_REGULATION_MAIN_TITLE_1)}</h2>
    const secondTitlePart = <h2 className='text-blue'>{t(TEXT_KEYS.EU_REGULATION_MAIN_TITLE_2)}</h2>
    const thirdTitlePart = <h2>{t(TEXT_KEYS.EU_REGULATION_MAIN_TITLE_3)} <h2 className='text-blue'>{t(TEXT_KEYS.EU_REGULATION_MAIN_TITLE_4)}</h2></h2>

    return (
        <div className='page-container'>
            <TitleWithIcon
                imagePath={IMAGES_PATH.LOGO_EU}
                firstTitlePart={firstTitlePart}
                secondTitlePart={secondTitlePart}
                thirdTitlePart={thirdTitlePart}
                isIconContainer={false}
            />
            <SectionBlueAndCartel
                title={t(TEXT_KEYS.EU_REGULATION_TITLE)}
                cartelItems={CARTEL_ITEMS}
            />
            <SectionModuleEURegulation />
            <SectionStore />
            <SectionSignUp />
        </div>
    );
};